import { Routes, Route, Link } from "react-router-dom";
import { SignedIn, SignedOut, RedirectToSignIn, SignIn, UserButton } from "@clerk/clerk-react";
import { SourceManager } from "./pages/SourceManager.js";

interface AppProps {
  devModeNoAuth?: boolean;
}

export function App({ devModeNoAuth }: AppProps) {
  if (devModeNoAuth) {
    return (
      <div className="bios-admin-shell">
        <Topbar dev />
        <main className="bios-admin-main">
          <Routes>
            <Route path="/" element={<SourceManager devModeNoAuth />} />
          </Routes>
        </main>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/sign-in/*" element={<div style={{ display: "grid", placeItems: "center", minHeight: "100vh" }}><SignIn routing="path" path="/sign-in" /></div>} />
      <Route
        path="/*"
        element={
          <>
            <SignedIn>
              <div className="bios-admin-shell">
                <Topbar />
                <main className="bios-admin-main">
                  <Routes>
                    <Route path="/" element={<SourceManager />} />
                  </Routes>
                </main>
              </div>
            </SignedIn>
            <SignedOut>
              <RedirectToSignIn />
            </SignedOut>
          </>
        }
      />
    </Routes>
  );
}

function Topbar({ dev }: { dev?: boolean }) {
  return (
    <header className="bios-admin-topbar">
      <Link to="/" style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <div className="bios-brand-mark">B</div>
        <span className="bios-admin-title">BIOS · Admin Console</span>
      </Link>
      {dev ? <span style={{ fontSize: 11, color: "var(--bios-text-faint)" }}>Dev mode</span> : <UserButton afterSignOutUrl="/" />}
    </header>
  );
}
